import { useEffect, useState } from "react";
import { FormikProvider, useFormik } from "formik";
import { DetailsImageVehicleRow } from "../fields-upload/DetailsImageVehicleRow";
import { IMaintenanceVisualRecord } from "../../../../../types/maintenance-visual-record.type";
import ModalAddPhotosMaintenance from "../modals/ModalAddPhotosMaintenance";

type VehicleStartMaintenanceDetailsProps = {
  data: IMaintenanceVisualRecord;
  onClose?: () => void;
};
export default function VehicleStartMaintenanceDetails(
  props: VehicleStartMaintenanceDetailsProps
) {
  const [action, setAction] = useState<{
    eventName: string;
    data: IMaintenanceVisualRecord;
  }>();

  const [data, setData] = useState(props.data);
  const [reload, setReload] = useState(false);
  const [vehicleId, setvehicleId] = useState<string | null>(null);

  const formik = useFormik({
    initialValues: {
      startMaintenance: props.data.photosMaintenance[0].startMaintenance,
    },
    onSubmit: (values) => {
      values;
    },
    // outras opções do Formik aqui
  });

  useEffect(() => {
    if (props.data !== undefined) {
      props.data && setvehicleId(vehicleId);
    }
  }, [props.data, vehicleId]);

  useEffect(() => {
    if (!action?.data) {
      return;
    }
    setData(action.data);
    formik.resetForm({
      values: {
        ...formik.values,
        startMaintenance:
          action.data.photosMaintenance[0]?.startMaintenance || [],
      },
    });
    setReload(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [action]);

  const reloadPage = () => {
    window.location.reload();
  };

  const isAction = (eventName: string) => action?.eventName === eventName;

  return (
    <div className="fixed inset-0 z-10 bg-black bg-opacity-30 flex justify-center items-center p-4">
      <FormikProvider value={formik}>
        <section
          style={{ backgroundColor: "rgb(179, 175, 175)" }}
          className=" flex flex-col items-center rounded-md shadow-lg max-w-[90%] md:max-w-2xl mx-auto p-4 max-h-[calc(100vh-4rem)] overflow-auto"
        >
          <h2 className="text-2xl font-semibold mb-4">
            Detalhes da Manutenção (Início)
          </h2>
          <div className="flex flex-wrap justify-center">
            {data.photosMaintenance[0]?.startMaintenance?.map((doc, index) => (
              <div
                key={index}
                className={`flex flex-col space-y-2 p-3 my-0 rounded ${
                  index % 2 ? "bg-gray/5" : "bg-gray/5"
                }`}
              >
                <DetailsImageVehicleRow
                  name={`startMaintenance.${index}`}
                  initialData={doc || {}}
                  prefix="start-maintenance"
                  vehicleId={data.vehicleId}
                />
              </div>
            ))}
          </div>

          <div className="flex justify-around w-full mt-4">
            <button
              onClick={() => {
                if (data._id) {
                  setAction({ eventName: "addFileMaintenance", data: data });
                } else {
                  alert("ID do Registro de Manutenção ausente.");
                }
              }}
              className="bg-redPrimary text-white w-34 border-black border-opacity-30 shadow-md relative self-end"
            >
              Adicionar Fotos
            </button>

            <button
              onClick={() => {
                props.onClose && props.onClose();
                reload && reloadPage();
              }}
              className="bg-redPrimary text-white w-24 border-black border-opacity-30 shadow-md relative self-end"
            >
              Fechar
            </button>
          </div>
        </section>

        {isAction("addFileMaintenance") && data._id && (
          <ModalAddPhotosMaintenance
            docType="start-maintenance"
            onClose={() => setAction(undefined)}
            vehicleId={data.vehicleId}
            visualRecordId={data._id as string}
            closeAndUpdate={(updatedData) =>
              setAction({ eventName: "photosAdded", data: updatedData })
            }
          ></ModalAddPhotosMaintenance>
        )}
      </FormikProvider>
    </div>
  );
}
